import { React } from '@gasbuddy/react';
import { Segment } from 'semantic-ui-react';
import { VerticalCenter } from '../vertical-center';

export const Unauthorized = () => (
  <VerticalCenter>
    <Segment textAlign="center" raised>
      <h1>Unauthorized</h1>
      <p>You do not have permissions to view this content.</p>
    </Segment>
  </VerticalCenter>
);
